
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { getBranchList, getCatalogList } from '../setting/services/settingApi'
import api from '../../api/api'
import { saveAs } from 'file-saver';
import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { REPORT_CONFIG } from './config'
import { MobileDatePicker } from '@mui/x-date-pickers';
import { PLAN_CONFIG } from '../plan/config';
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReportInspection() {
    const [branchs, setBranchs] = useState([])

    const [BranchNo, setBranchsNo] = useState('')
    const [docdate, setdocdate] = useState()
    const [reports, setReports] = useState([])
    const [CampaignList, setCampaignList] = useState([])
    const [filteredCampaigns, setFilteredCampaigns] = useState([])
    const [InspectionDocNo, setInspectionDocNo] = useState()
    const [sumValue, setSumValue] = useState()
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);

    const { profile } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };



    async function getCampaignList() {
        const res = await api.get(PLAN_CONFIG.requests.getPlanCampaigns.url);
        const data = res.data.result
        setCampaignList(data)
        setFilteredCampaigns(data?.filter(e => {
            return e.BranchNo === profile?.BranchNo?.BranchNo
        }))
    }

    useEffect(() => {
        getBranchList(null, setBranchs)
        getCampaignList()
    }, [])
    function calculateSum() {
        const sumValue = { Qty: 0, TotalPrice: 0 }

        for (const row of reports) {
            sumValue.Qty += +row.Qty
            sumValue.TotalPrice += +row.TotalPrice
        }
        setSumValue(sumValue)
    }
    useEffect(() => {
        calculateSum()
    }, [reports])
    useEffect(() => {
        if (profile?.BranchNo?.BranchNo) {
            setBranchsNo(profile?.BranchNo?.BranchNo)
        }
    }, [profile])

    async function getReportInspection(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getReportInspection.url}/${mode}`;


        let _params = '';

        let _InspectionDocNo = '';

        let _branchNo = '';
        let _format = '';



        if (body.InspectionDocNo) {
            _InspectionDocNo = 'inspectionDocNo=' + (body.InspectionDocNo !== '-' ? body.InspectionDocNo : '');
        }

        if (body.branchNo) {
            _branchNo = '&branchNo=' + (body.branchNo !== '-' ? body.branchNo : '');
        }


        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _InspectionDocNo + _branchNo + _format
        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'ใบตรวจการปฏิบัติงาน (กมข-30403)');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'ใบตรวจการปฏิบัติงาน (กมข-30403)');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport() {
        const body = {
            InspectionDocNo: InspectionDocNo || undefined,
            branchNo: BranchNo || undefined,
        };
        getReportInspection(body, 'data');

    }
    function onFilterChange(e) {
        const selectedBranch = BranchNo || undefined
        const selectedDate = dayjs(e).format('YYYY-MM-DD') || undefined

        let filteredCampaigns = []
        if (selectedDate) {
            filteredCampaigns = CampaignList.filter(e => {
                return dayjs(e.InspectionDocDate).format('YYYY-MM-DD') === selectedDate
                    && ("00" === selectedBranch || e.BranchNo === selectedBranch)

            })
        }


        else
            filteredCampaigns = CampaignList.filter(e => {
                return "00" === selectedBranch || e.BranchNo === selectedBranch
            })
        setFilteredCampaigns(filteredCampaigns)
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form>
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">
                                    {profile?.BranchNo?.BranchNo === '00' &&
                                        <div class="col-12">

                                            <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <FormControl variant="standard" fullWidth >
                                                    <Select value={BranchNo || '-'} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                                        <MenuItem value='-'>-</MenuItem>
                                                        {branchs?.map((x) => (
                                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>}
                                    <div class="col-12">

                                        <label class="labelInput">ลงวันที่ (คำสั่ง)</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={docdate} onChange={e => {
                                                    setdocdate(e)
                                                    onFilterChange(e)
                                                }}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: docdate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>


                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">เลขที่คำสั่งกรมการข้าว / โครงการ</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={InspectionDocNo || '-'} onChange={e => setInspectionDocNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {filteredCampaigns?.map((x) => (
                                                        <MenuItem value={x?.InspectionDocNo}>{x?.InspectionDocNo} {x?.CampaignName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>

                                    </div>



                                    <div class="col-12">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>

                                    </div >

                                </div >
                            </div >
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            ใบตรวจการปฏิบัติงาน (กมข-30403)
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    InspectionDocNo: InspectionDocNo || undefined,
                                                    branchNo: BranchNo || undefined,
                                                };
                                                // setFormat('')
                                                getReportInspection(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    InspectionDocNo: InspectionDocNo || undefined,
                                                    branchNo: BranchNo || undefined,
                                                };
                                                // setFormat('pdf')
                                                getReportInspection(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div >

                                </div >
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">

                                        <div class="table-responsive-sm" style={{ height: "auto" }}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>

                                                        <th scope="col " rowspan="2" class="text-center">จังหวัด</th>
                                                        <th scope="col " rowspan="2" class="text-center">พันธุ์/ชั้นพันธุ์</th>
                                                        <th scope="col " rowspan="2" class="text-center">ราคารวมค่าขนส่ง (บาท/กิโลกรัม)</th>
                                                        <th scope="col " rowspan="2" class="text-center">จำนวนเมล็ดพันธุ์ (กิโลกรัม)</th>
                                                        <th scope="col " rowspan="2" class="text-center">จำนวนเงินค่าเมล็ดพันธุ์ (บาท)</th>
                                                        <th scope="col " colspan="5" class="text-center">คุณภาพ</th>
                                                    </tr>
                                                    <tr>

                                                        <th scope="col " class="text-center">ความงอก (%)</th>
                                                        <th scope="col " class="text-center">เมล็ดพันธุ์สุทธิ (%)</th>
                                                        <th scope="col " class="text-center">พันธุ์ปน (จำนวนเมล็ดใน 500 กรัม)</th>
                                                        <th scope="col " class="text-center">ข้าวแดง (จำนวนเมล็ดใน 500 กรัม)</th>
                                                        <th scope="col " class="text-center">ความชื้น (%)</th>
                                                    </tr>

                                                </thead>
                                                <tbody class="">
                                                    {reports?.map((d, i) => (

                                                        <tr >

                                                            <td class="text-center">{d?.Province}</td>
                                                            <td class="text-center">{d?.Item}</td>
                                                            <td class="text-center">{d?.SalePrice}</td>
                                                            <td class="text-center">{d?.Qty.toLocaleString()}</td>
                                                            <td class="text-center">{parseFloat(d?.TotalPrice).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                            <td class="text-center">{d?.Germin}</td>
                                                            <td class="text-center">{d?.NetPercent}</td>
                                                            <td class="text-center">{d?.Mixed}</td>
                                                            <td class="text-center">{d?.RedRice}</td>
                                                            <td class="text-center">{d?.Humid}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <thead class="sticky-tfooter">
                                                    <tr>
                                                        <th scope="col " colspan="3" class="text-center">รวม</th>
                                                        <th scope="col " class="text-center">{sumValue?.Qty.toLocaleString()}</th>
                                                        <th scope="col " class="text-center">{parseFloat(sumValue?.TotalPrice).toFixed(2)
                                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</th>
                                                        <th scope="col " colspan="5" class="text-center"></th>
                                                    </tr>

                                                </thead>

                                            </table>
                                        </div>
                                    </div>
                                </div >
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div >

                        </div >

                    </form >
                </div >
            </Page >
        </div >
    )
}
